import React from 'react';
import { IonIcon, IonListHeader } from '@ionic/react';
import { ExploreElement } from 'models/ExploreElementModel/ExploreElementModel';
import ExploreFavoriteCard from 'components/listElements/ExploreFavoriteCard/ExploreFavoriteCard';
import Trans from 'util/Trans';
import { Swiper, SwiperSlide } from 'swiper/react';

interface FavoritesSectionProps {
  favorites: ExploreElement[];
  activeTab: number;
  onOpenPersonModal: (element: ExploreElement, score: number) => void;
  onOpenEventModal: (element: ExploreElement) => void;
  onOpenRankingModal: (element: ExploreElement) => void;
  onOpenContestModal: (element: ExploreElement) => void;
}

const FavoritesSection: React.FC<FavoritesSectionProps> = ({
  favorites,
  activeTab,
  onOpenPersonModal,
  onOpenEventModal,
  onOpenRankingModal,
  onOpenContestModal,
}) => {
  if (favorites.length === 0) return null;

  return (
    <div id="favorites" className="section-container">
      <IonListHeader style={{ paddingLeft: '0', marginBottom: '8px' }}>
        <IonIcon
          src={`/assets/icons/star_filled.svg`}
          style={{ width: '0.85em', marginLeft: '8px' }}
        />
        <Trans i18nKey="Favorites">Favoriten</Trans>
        <span className="section-count" style={{ color: 'var(--ion-color-primary)' }}>({favorites.length})</span>
      </IonListHeader>
      <Swiper
        slidesPerView="auto"
        spaceBetween={8}
        slidesOffsetAfter={4}
        slidesOffsetBefore={4}
        className="animated animate__animated animate__fadeInLeft animate__faster"
      >
        {favorites.map((favorite) => (
          <div
            key={favorite.id}
            className="favorite-item"
            onClick={() =>
              onOpenPersonModal(favorite, (favorite as any).score ?? 0)
            }
          >
            <SwiperSlide>
              <ExploreFavoriteCard
                item={favorite}
                isFriend={activeTab === 1}
                onOpenPersonModal={(item) =>
                  onOpenPersonModal(item, (item as any).score ?? 0)
                }
                onOpenEventModal={onOpenEventModal}
                onOpenRankingModal={onOpenRankingModal}
                onOpenContestModal={onOpenContestModal}
              />
            </SwiperSlide>
          </div>
        ))}
      </Swiper>
    </div>
  );
};

export default FavoritesSection;
